// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * fps-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: local
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ProfileIdentificationStatusAPIModel {
    Verified = 'Verified',
    InProgress = 'InProgress',
    NotVerified = 'NotVerified',
    VerificationFailed = 'VerificationFailed'
}

export function ProfileIdentificationStatusAPIModelFromJSON(json: any): ProfileIdentificationStatusAPIModel {
    return ProfileIdentificationStatusAPIModelFromJSONTyped(json, false);
}

export function ProfileIdentificationStatusAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileIdentificationStatusAPIModel {
    return json as ProfileIdentificationStatusAPIModel;
}

export function ProfileIdentificationStatusAPIModelToJSON(value?: ProfileIdentificationStatusAPIModel | null): any {
    return value as any;
}

